// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSurchargeCard_root__MYA2k","text":"PlasmicSurchargeCard_text__q+esD"};